import { Card } from "materia"
import s from "./FeaturedProducts.module.scss"

export const FeaturedProductsSkeleton = () => {
  return (
    <Card>
      <div className={s.skeleton}>
        <div className={s.skeleton__featured} />
        <div className={s.skeleton__title} />
      </div>
    </Card>
  )
}
